import { Link } from "react-router-dom";
import { Mail, MessageCircle, MapPin } from "lucide-react";
import BrandLockup from "./BrandLockup";
import { BRAND } from "../data/content";
import { useT, useLang } from "../i18n/LanguageContext";
import { BRAND_DESCRIPTION_IT } from "../i18n/content_it";
import { LegalDisclaimer } from "./LegalDisclaimer";

export default function Footer() {
  const t = useT();
  const { lang } = useLang();
  const description = lang === "it" ? BRAND_DESCRIPTION_IT : BRAND.description;
  return (
    <footer data-testid="site-footer" className="relative bg-[#0A0A0A] border-t border-white/10 px-6 md:px-12 pt-20 pb-10">
      <div className="max-w-[1600px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <BrandLockup size="footer" align="left" />
          <p className="text-white/60 mt-6 max-w-sm leading-relaxed text-sm">
            {description}
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="overline mb-5">{t("footer.contact")}</p>
          <a href={`mailto:${BRAND.email}`} data-testid="footer-email" className="flex items-center gap-3 text-white/70 hover:text-[#C5A059] transition-colors mb-4 text-sm">
            <Mail size={16} /> {BRAND.email}
          </a>
          <a href={BRAND.whatsappHref} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 text-white/70 hover:text-[#C5A059] transition-colors mb-4 text-sm">
            <MessageCircle size={16} /> {BRAND.whatsapp}
          </a>
          <div className="flex items-center gap-3 text-white/70 text-sm">
            <MapPin size={16} /> {t("footer.location")}
          </div>
        </div>

        <div className="md:col-span-4">
          <p className="overline mb-5">{t("footer.explore")}</p>
          <div className="grid grid-cols-2 gap-x-8 gap-y-3 text-sm">
            <Link to="/services" className="text-white/70 hover:text-[#C5A059] transition-colors">{t("nav.services")}</Link>
            <Link to="/cruise-tours" className="text-white/70 hover:text-[#C5A059] transition-colors">{t("nav.journeys")}</Link>
            <Link to="/livorno-cruise-transfers" data-testid="footer-cruise-guide" className="text-white/70 hover:text-[#C5A059] transition-colors">{t("footer.cruiseGuide")}</Link>
            <Link to="/pisa-florence-airport-transfers" data-testid="footer-airport-guide" className="text-white/70 hover:text-[#C5A059] transition-colors">{t("footer.airportGuide")}</Link>
            <Link to="/viareggio-carrara-yacht-transfers" data-testid="footer-yacht-guide" className="text-white/70 hover:text-[#C5A059] transition-colors">{t("footer.yachtGuide")}</Link>
            <Link to="/tuscany-wine-tours" data-testid="footer-wine-guide" className="text-white/70 hover:text-[#C5A059] transition-colors">{t("footer.wineGuide")}</Link>
            <Link to="/florence-private-tour" data-testid="footer-florence-guide" className="text-white/70 hover:text-[#C5A059] transition-colors">{t("footer.florenceGuide")}</Link>
            <Link to="/cinque-terre-private-tour" data-testid="footer-cinqueterre-guide" className="text-white/70 hover:text-[#C5A059] transition-colors">{t("footer.cinqueTerreGuide")}</Link>
            <Link to="/val-orcia-private-tour" data-testid="footer-valdorcia-guide" className="text-white/70 hover:text-[#C5A059] transition-colors">{t("footer.valdorciaGuide")}</Link>
            <Link to="/privacy" data-testid="footer-privacy" className="text-white/70 hover:text-[#C5A059] transition-colors">{t("form.privacyPolicy")}</Link>
            <Link to="/cookie-policy" data-testid="footer-cookie" className="text-white/70 hover:text-[#C5A059] transition-colors">{t("cookie.policyLink")}</Link>
            <Link to="/cancellation-policy" data-testid="footer-cancellation" className="text-white/70 hover:text-[#C5A059] transition-colors">{t("form.cancellationPolicy")}</Link>
            <Link to="/terms" data-testid="footer-terms" className="text-white/70 hover:text-[#C5A059] transition-colors">{t("form.termsService")}</Link>
          </div>
        </div>
      </div>

      <div className="max-w-[1600px] mx-auto mt-16 pt-8 border-t border-white/10">
        <LegalDisclaimer className="max-w-4xl mb-6" />
        <div className="flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
          <span>{BRAND.legalName} — {BRAND.address} — VAT / P.IVA {BRAND.vat} — C.F. {BRAND.cf}</span>
          <span>© {new Date().getFullYear()} Your Black Limo. {t("footer.rights")}</span>
        </div>
      </div>
    </footer>
  );
}
